export default class IncomeCategoryService {

  static apiRelativePath = "/income-categories"

  constructor(apiClient) {
    this.apiClient = apiClient;
  }

  getAll = async () => {
    return this.apiClient.get(`${IncomeCategoryService.apiRelativePath}`);
  }

  create = async (data) => {
    return this.apiClient.post(`${IncomeCategoryService.apiRelativePath}`, data);
  }

  put = async (id, data) => {
    return this.apiClient.put(`${IncomeCategoryService.apiRelativePath}/${id}`, data);
  }

  delete = async (id) => {
    return this.apiClient.delete(`${IncomeCategoryService.apiRelativePath}/${id}`);
  }

  reorder = async (data) => {
    return this.apiClient.post(`${IncomeCategoryService.apiRelativePath}/reorder`, data);
  }
}
